import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [form, setForm] = useState({
    name: '', email: '', phone: '', company: '', product: '', message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   setSending(true);
  //   // Simulate send - integrate with EmailJS or similar
  //   setTimeout(() => {
  //     setSending(false);
  //     setSubmitted(true);
  //   }, 1500);
  // };
  const handleSubmit = (e) => {
  e.preventDefault();

  const whatsappNumber = "919848782799"; // Your WhatsApp number

  const text = `Hello Sri Sai Engineerings,

I would like to enquire about your rice mill machinery services.

📌 Customer Details
-------------------------
👤 Full Name: ${form.name}
📧 Email: ${form.email}
📱 Phone: ${form.phone}
🏢 Company/Mill Name: ${form.company || 'Not Provided'}

⚙️ Product Interested In:
${form.product || 'Not Specified'}

📝 Requirements / Message:
${form.message}

Please contact me with more details. Thank you!`;

  const encodedText = encodeURIComponent(text);

  const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodedText}`;

  window.open(whatsappURL, '_blank');

  setSubmitted(true);

  setForm({
    name: '',
    email: '',
    phone: '',
    company: '',
    product: '',
    message: '',
  });
};

  return (
    <div className="contact-page">
      {/* Hero */}
      <div className="contact-hero">
        <div className="contact-hero-bg" />
        <div className="container">
          <span className="section-label" style={{ color: 'rgba(255,255,255,0.5)' }}>Get In Touch</span>
          <h1 className="contact-hero-title">Let's Build Your<br /><span>Perfect Rice Mill</span></h1>
          <p className="contact-hero-sub">
            Contact our engineering team for product enquiries, technical consultations, or turnkey project quotes.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="contact-main">
        <div className="container">
          <div className="contact-grid">
            {/* Info Panel */}
            <div className="contact-info">
              <h3 className="ci-title">Contact Information</h3>

              <div className="ci-card">
                <div className="ci-icon">📍</div>
                <div>
                  <h4>Factory Address</h4>
                  <p>D.No.1-43 Opp: Rajya Lakshmi Theatre<br />Uppal, Hyderabad – 500 039<br />Telangana, India</p>
                </div>
              </div>

              <div className="ci-card">
                <div className="ci-icon">📞</div>
                <div>
                  <h4>Phone Numbers</h4>
                  <p>
                    <a href="tel:+919848027990">+91 9848027990</a><br />
                    <a href="tel:+919948127994">+91 9948127994</a><br />
                    <a href="tel:+919848782799">+91 9848782799</a>
                  </p>
                </div>
              </div>

              <div className="ci-card">
                <div className="ci-icon">✉️</div>
                <div>
                  <h4>Email</h4>
                  <p><a href="mailto:srisaiengs@gmail.com">srisaiengs@gmail.com</a></p>
                </div>
              </div>

              <div className="ci-card">
                <div className="ci-icon">🕐</div>
                <div>
                  <h4>Working Hours</h4>
                  <p>Monday – Saturday<br />9:00 AM – 7:00 PM IST</p>
                </div>
              </div>

              <div className="ci-products">
                <h4>We specialize in:</h4>
                <div className="ci-product-tags">
                  {['Paddy Cleaners', 'Pneumatic Huskers', 'Whiteners', 'Polishers', 'Destoners', 'Elevators', 'Graders', 'Air Lock Systems'].map(tag => (
                    <span key={tag} className="ci-tag">{tag}</span>
                  ))}
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="contact-form-panel">
              {submitted ? (
                <div className="form-success">
                  <div className="success-icon">✅</div>
                  <h3>Enquiry Received!</h3>
                  <p>Thank you for contacting Sri Sai Engineerings. Our team will reach out to you within 24 hours.</p>
                  <button onClick={() => { setSubmitted(false); setForm({ name: '', email: '', phone: '', company: '', product: '', message: '' }); }}>
                    Send Another Enquiry
                  </button>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <h3 className="form-title">Send Enquiry</h3>
                  <p className="form-subtitle">Fill in the form and we'll respond within 24 hours.</p>

                  <div className="form-row">
                    <div className="form-field">
                      <label>Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Your full name"
                        value={form.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-field">
                      <label>Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="your@email.com"
                        value={form.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-field">
                      <label>Phone Number *</label>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="+91 9XXXXXXXXX"
                        value={form.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-field">
                      <label>Company / Mill Name</label>
                      <input
                        type="text"
                        name="company"
                        placeholder="Your rice mill / company name"
                        value={form.company}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-field">
                    <label>Product of Interest</label>
                    <select name="product" value={form.product} onChange={handleChange}>
                      <option value="">Select a product (optional)</option>
                      <option>Paddy Cleaner</option>
                      <option>Pre Cleaner</option>
                      <option>Vibro Paddy Destoner</option>
                      <option>Pneumatic Husker</option>
                      <option>Husk Aspirator</option>
                      <option>Paddy Separator (Delux)</option>
                      <option>Whitener</option>
                      <option>Glaze Master Cum Silky Polisher</option>
                      <option>Rice Destoner</option>
                      <option>Poly M-3</option>
                      <option>Multi Grader</option>
                      <option>Air Lock System</option>
                      <option>Geared Elevators</option>
                      <option>Complete Turnkey Rice Mill Setup</option>
                    </select>
                  </div>

                  <div className="form-field">
                    <label>Message / Requirements *</label>
                    <textarea
                      name="message"
                      rows="5"
                      placeholder="Describe your requirements — milling capacity, existing setup, location, budget, etc."
                      value={form.message}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <button type="submit" className="form-submit" disabled={sending}>
                    {sending ? (
                      <span className="sending-text">
                        <span className="spinner" /> Sending...
                      </span>
                    ) : (
                      'Send Enquiry on Whatsapp→'
                    )}
                  </button>

                  <p className="form-note">
                    * By submitting, you agree to be contacted by Sri Sai Engineerings regarding your enquiry.
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Map Placeholder */}
      <div className="map-section">
        <div className="map-placeholder">
          <div className="map-overlay">
            <div className="map-pin">📍</div>
            <h4>Sri Sai Engineerings</h4>
            <p>D.No.1-43 Opp: Rajya Lakshmi Theatre, Uppal, Hyderabad – 500 039</p>
            <a
              href="https://maps.app.goo.gl/5cn9untEXXdn3AsS6?g_st=iwb"
              target="_blank"
              rel="noopener noreferrer"
              className="map-btn"
            >
              Open in Google Maps →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
